import { CloseIcon } from "assets";
import { links } from "data";
import { useAccordionContext } from "domain/accordion";
import { useMemo } from "react";
import { ABOUT_ACCORDION_KEY, AboutAccordion } from "./about-accordion";
import { AccordionLink } from "./accordion-link";
import {
  MY_ACCOUNT_ACCORDION_KEY,
  MyAccountAccordion,
} from "./my-account-accordion";
import { RotatableChevron } from "./rotatable-chevron";
import {
  SERVICES_ACCORDION_KEY,
  ServicesAccordion,
} from "./services-accordion";
import { SUPPORT_ACCORDION_KEY, SupportAccordion } from "./support-accordion";
import styles from "./wrapper-accordion.module.scss";
import logo from "assets/logo.jpeg";

export const WRAPPER_ACCORDION_KEY = "WRAPPER_ACCORDION_KEY";

export const WrapperAccordion = () => {
  const { getControls, createAccordion, isOpen } = useAccordionContext();

  const { switch: switchServicesAccordion } = getControls(
    SERVICES_ACCORDION_KEY
  );

  const { switch: switchAboutAccordion } = getControls(ABOUT_ACCORDION_KEY);

  const { switch: switchSupportAccordion } = getControls(SUPPORT_ACCORDION_KEY);

  const { switch: switchMyAccountAccordion } = getControls(
    MY_ACCOUNT_ACCORDION_KEY
  );

  const { element: Accordion, close: closeWrapperAccordion } = useMemo(
    () => createAccordion(WRAPPER_ACCORDION_KEY),
    []
  );

  return (
    <div className={styles.container}>
      <Accordion accordionKey={WRAPPER_ACCORDION_KEY}>
        <div className={styles.content}>
          <div className={styles.subheader}>
            <a href={links.HOMEPAGE}>
              <img
                src={logo}
                className={styles.logo}
                title="CitySprint header logo"
                alt="CitySprint header logo"
              />
            </a>
            <CloseIcon
              className={styles.close}
              onClick={closeWrapperAccordion}
            />
          </div>
          <div className="py-st">
            <AccordionLink href={links.HOMEPAGE}>Home</AccordionLink>
            <AccordionLink onClick={switchServicesAccordion}>
              Services
              <RotatableChevron isOpen={isOpen(SERVICES_ACCORDION_KEY)} />
            </AccordionLink>
            <ServicesAccordion />
            <AccordionLink onClick={switchAboutAccordion}>
              About us
              <RotatableChevron isOpen={isOpen(ABOUT_ACCORDION_KEY)} />
            </AccordionLink>
            <AboutAccordion />
            <AccordionLink onClick={switchSupportAccordion}>
              Support
              <RotatableChevron isOpen={isOpen(SUPPORT_ACCORDION_KEY)} />
            </AccordionLink>
            <SupportAccordion />
            <AccordionLink href={links.SIGN_UP_FOR_AN_ACCOUNT}>
              Sign up for an account
            </AccordionLink>
            <AccordionLink href={links.BECOME_A_COURIER}>
              Become a courier
            </AccordionLink>
            <AccordionLink onClick={switchMyAccountAccordion}>
              My account
              <RotatableChevron isOpen={isOpen(MY_ACCOUNT_ACCORDION_KEY)} />
            </AccordionLink>
            <MyAccountAccordion />
          </div>
        </div>
      </Accordion>
    </div>
  );
};
